import $ from "jquery";
import html2canvas from "html2canvas";
import { ToolbarButton } from "../../lib/ui/toolbar/buttons";
export class PrintButton extends ToolbarButton {
    constructor() {
        super('print', 'Print Current Map View', 'printButton');
        this.static_legend = $();
        this.static_layerbox = $();
        this.static_colorize = $();
        this.original_state = {
            legend_hidden: false,
            colorize_hidden: false,
            layerbox_hidden: false,
        };
    }
    generate_static_legend() {
        let box = $("#thematicbox");
        this.static_legend = box.clone().attr("id", "static-legend");
        this.static_legend.css({
            "position": "fixed",
            "z-index": 10000,
            "left": ".5em",
            "bottom": "2em",
            "width": "400px",
            "background-color": "rgba(243, 243, 243, 1)",
            "border": "2px solid rgba(0, 0, 0, 0.4)",
            "border-radius": "5px",
            "padding": "4px 8px 6px 8px"
        });
        this.static_legend.find(".layer.active > .legend").css("display", "block");
        this.static_legend.appendTo("body");
        box.addClass("hidden");
    }
    generate_static_colorize() {
        let lgd = $("#colorize-legend");
        this.static_colorize = lgd.clone().attr("id", "static-colorize");
        this.static_colorize.css({
            "position": "fixed",
            "z-index": 10000,
            "left": ".5em",
            "bottom": "2em",
            "width": "400px",
            "background-color": "rgba(243, 243, 243, 1)",
            "border": "2px solid rgba(0, 0, 0, 0.4)",
            "border-radius": "5px",
            "padding": "4px 8px 6px 8px"
        });
        this.static_colorize.find(".layer.active > .legend").css("display", "block");
        this.static_colorize.appendTo("body");
        lgd.addClass("hidden");
    }
    generate_static_layerbox() {
        let layerbox = $("#layerbox");
        this.static_layerbox = layerbox.clone();
        this.static_layerbox.attr("id", "static-layerbox");
        this.static_layerbox.css({
            "position": "fixed",
            "z-index": 10000,
            "margin-top": "36px",
            "right": ".5em",
            "overflow": "auto",
            "width": "300px",
            "background-color": "rgba(243, 243, 243, 0.9)",
            "border": "2px solid rgba(0, 0, 0, 0.4)",
            "border-radius": "5px",
            "padding": "4px 8px 6px 8px",
            "max-height": "80%",
            "top": 0
        });
        this.static_layerbox.find(".header").css({
            "font-weight": "600",
            "text-align": "center",
            "margin-top": "2px",
            "background-color": "rgba(66, 133, 244, 0.3)",
            "border-radius": "7px 7px 0 0"
        });
        this.static_layerbox.find(".layer").css("padding", "3px");
        this.static_layerbox.find(".layer > select").css({
            "display": "none",
            "margin-left": "20px"
        });
        this.static_layerbox.appendTo("body");
        layerbox.addClass("hidden");
    }
    if_hidden_else(element, callbackIf, callbackElse) {
        if (element.hasClass("hidden"))
            return callbackIf(element);
        callbackElse(element);
    }
    reselect() {
        let orig_id = this.static_layerbox.find("input[name=baseLayers]:checked").val();
        $("#layerbox").find(`input[value=${orig_id}]`).prop("checked", true);
    }
    before_print() {
        $("#status-bar").addClass("hidden");
        $("#info-header").addClass("hidden");
        $(".toolBar").addClass("hidden");
        $(".ol-zoom").addClass("hidden");
        this.if_hidden_else($("#thematicbox"), () => { this.original_state.legend_hidden = true; }, () => this.generate_static_legend());
        this.if_hidden_else($("#layerbox"), () => { this.original_state.layerbox_hidden = true; }, () => this.generate_static_layerbox());
        this.if_hidden_else($("#colorize-legend"), () => { this.original_state.colorize_hidden = true; }, () => this.generate_static_colorize());
        this.ui.addClass('highlighted');
    }
    after_print() {
        $("body").css('opacity', 0.5);
        this.reselect();
        this.static_legend.remove();
        this.static_legend = $();
        this.static_layerbox.remove();
        this.static_layerbox = $();
        this.static_colorize.remove();
        this.static_colorize = $();
        $("#thematicbox").toggleClass("hidden", this.original_state.legend_hidden);
        $("#layerbox").toggleClass("hidden", this.original_state.layerbox_hidden);
        $("#colorize-legend").toggleClass("hidden", this.original_state.colorize_hidden);
        $(".ol-zoom").removeClass("hidden");
        $(".toolBar").removeClass("hidden");
        $("#info-header").removeClass("hidden");
        $("#status-bar").removeClass("hidden");
        this.original_state.layerbox_hidden = false;
        this.original_state.legend_hidden = false;
        this.original_state.colorize_hidden = false;
        this.ui.removeClass('highlighted');
    }
    _action() {
        this.before_print();
        html2canvas(document.body, {
            allowTaint: true,
            useCORS: true,
            logging: false,
        }).then((canvas) => {
            this.after_print();
            let link = document.createElement("a");
            link.setAttribute("download", `map-${new Date(Date.now()).toLocaleTimeString("en-US").replace(" ", "").replace(":", "_")}.png`);
            let img = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
            link.setAttribute("href", img);
            link.click();
            $("body").css("opacity", 1);
            link.remove();
        });
    }
}
